module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg14-ed68ba852f18bce391eeda37a66f84a8.png";